import parsePhoneNumber from 'libphonenumber-js';

export const formatCurrency = (currency: any) => {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'Php',
      });
    return formatter.format(currency);
}

export const normalizePhoneNumber = (raw: string, defaultCountry:any = 'PH') => {
  try {
    const phone = parsePhoneNumber(raw, defaultCountry);
    if (phone?.isValid()) {
      return phone.format('E.164'); // → +639123456789
    }
  } catch (e) {
    return raw;
  }
  return raw;
}